import Card from 'react-bootstrap/Card';
import '../style/PersonalityAnalysisCard.css';
import Chart from 'react-apexcharts';
import StatusButton from '../../../UI/status-button/StatusButton';
import {ApexOptions} from 'apexcharts';
import {PersonalityAnalysisCardProp} from '../interface/IQuiz';

function PersonalityAnalysisCard({report, title}: PersonalityAnalysisCardProp) {
  console.log('report course exam' , report )
  let options: ApexOptions = {
    series: [report?.percentage ? report.percentage : 0],
    chart: {
      type: 'radialBar',
      offsetY: -20,
      sparkline: {
        enabled: true,
      },
    },
    colors: ['#39b970'],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#eeeeee',
          margin: 5, // margin is in pixels
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            offsetY: -2,
            fontSize: '22px',
          },
        },
      },
    },
    grid: {
      padding: {
        top: -10,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'vertical',
        gradientToColors: ['#87D4F9'],
        stops: [0, 100],
      },
    },
    labels: ['Average Results'],
  };
  return (
    <Card className="text-center main-card">
      <Card.Body className="mb-4 mt-3">
        <Chart options={options} series={options.series} type="radialBar" />
        <p className="mb-4">{title} Quiz</p>
        <StatusButton
          status={`${ ( report?.percentage ?? 0 )  >=  ( report?.passing_percentage ?? 0 ) ? 'Pass' : 'Fail'}`}
          background="rgba(57, 185, 112, .1)"
          color="#39b970"
        />
      </Card.Body>
    </Card>
  );
}

export default PersonalityAnalysisCard;
